import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

type LoadingVariant = 'spinner' | 'skeleton' | 'button';
type LoadingSize = 'sm' | 'md' | 'lg';

interface LoadingIndicatorProps {
  variant?: LoadingVariant;
  size?: LoadingSize;
  className?: string;
}

const spinnerSizes: Record<LoadingSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

const buttonSizes: Record<LoadingSize, string> = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

export function LoadingIndicator({
  variant = 'spinner',
  size = 'md',
  className,
}: LoadingIndicatorProps) {
  if (variant === 'skeleton') {
    return (
      <div
        className={cn(
          'animate-pulse rounded-md bg-neutral-200 dark:bg-neutral-700',
          'h-4 w-full',
          className
        )}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  if (variant === 'button') {
    return (
      <Loader2
        className={cn('animate-spin', buttonSizes[size], className)}
        aria-hidden="true"
      />
    );
  }

  // Default: spinner
  return (
    <div
      className={cn('flex items-center justify-center', className)}
      role="status"
      aria-label="Loading"
    >
      <Loader2 className={cn('animate-spin text-primary-600', spinnerSizes[size])} />
      <span className="sr-only">Loading...</span>
    </div>
  );
}
